import report from '@/service/report';
import createStore from '@/store/base/create-store';

const { state, actions, mutations } = createStore(report);
const modules = {};
const getters = {};
const tempState = {
    reportData: [],
    ...state
};
const tempMutations = {
    ...mutations
};
const tempActions = {
    /**
     * 初始化
     */
    init({ dispatch, commit, state }, param) {
        const { host } = param;
        // 获取参数
        const combineParam = {
            fellow_unique_id: param.query.account_id,
            host
        };
        return dispatch('getAnnualReport', combineParam).then(res => {
            if (res.result_code === 'success') {
                state.reportData = res.data || [];
            }
            return state.reportData;
        });
    },
    ...actions
};
const store = {
    namespaced: true,
    strict: true,
    getters,
    modules,
    state: tempState,
    actions: tempActions,
    mutations: tempMutations
};
export default store;



// WEBPACK FOOTER //
// ./src/store/report.js